module.exports = __webpack_public_path__ + "static/media/aims_5-1.63e45e59.png";